<template>
	<div class="grid">
		<div class="col-12">
			<div class="card">
				<h5>{{ $t('showerDevice.title') }}</h5>
				<!-- <div class="formgroup-inline" v-if="locaInfo.admin != 0">
					<Button label="新增花洒" icon="pi pi-plus" class="mr-2" @click="openEditDevice('add', '')" />
				</div> -->
				<div class="formgroup-inline mt-3">
					<span class="p-float-label mr-3">
						<Dropdown id="eventEnterprise" :options="enterpriseList" v-model="searchParams.enterpriseId"
							optionLabel="name" optionValue="id" filter @change="onEnterpriseChange('search')" :placeholder="$t('showerDevice.filters.enterprise')"
							show-clear="true"></Dropdown>
					</span>
					<span class="p-float-label mr-3">
						<Dropdown id="eventField" :options="fieldList" v-model="searchParams.enterprisePartitionId"
							:placeholder="$t('showerDevice.filters.field')" optionLabel="site_name" optionValue="id" filter @change="onFieldChange('search')"
							show-clear="true"></Dropdown>
					</span>
					<span class="p-float-label mr-3">
						<Dropdown id="regionId" :options="regionList" v-model="searchParams.regionId" :placeholder="$t('showerDevice.filters.region')"
							optionLabel="region_name" optionValue="id" filter show-clear="true"></Dropdown>
					</span>
					<span class="p-float-label mr-3">
						<Dropdown id="isOnline" :options="onlineStOpts" v-model="searchParams.isOnline" :placeholder="$t('showerDevice.filters.onlineStatus')"
							optionLabel="text" optionValue="value" show-clear="true"></Dropdown>
					</span>
					<span class="p-float-label mr-3">
						<Dropdown id="isDeploy" :options="deployStOpts" v-model="searchParams.isDeploy" :placeholder="$t('showerDevice.filters.deployStatus')"
							optionLabel="text" optionValue="value" show-clear="true"></Dropdown>
					</span>

					<div class="field">
						<label for="cameraNameSearch" class="p-sr-only">{{ $t('showerDevice.filters.sn') }}</label>
						<InputText id="cameraNameSearch" type="text" v-model="searchParams.sn" :placeholder="$t('showerDevice.filters.sn')" />
					</div>

					<Button :label="$t('showerDevice.search')" @click="onSearch()"></Button>
				</div>
			</div>
		</div>

		<div class="col-12">
			<div class="card">
				<DataTable :value="deviceList" :paginator="true" :rows="10" dataKey="id" :rowHover="true"
					filterDisplay="menu" v-model:selection="selectedDevice" responsiveLayout="scroll" selectionMode="single"
					:lazy="true" :totalRecords="totalCount" @page="onPage">
					<template #header>
						<div class="grid grid-nogutter">
							<div class="col-6 text-left">
							</div>
							<div class="col-6 text-right" style="margin-top:0px;">
								{{ $t('showerDevice.header.total', { count: totalCount }) }}
							</div>
						</div>
					</template>
					<template #empty>
						{{ $t('showerDevice.states.empty') }}
					</template>
					<template #loading>
						{{ $t('showerDevice.states.loading') }}
					</template>

					<Column field="name" header="SN" style="min-width:10rem">
						<template #body="{ data }">
							{{ data.sn }}
						</template>
					</Column>
					<Column field="name" :header="$t('showerDevice.columns.version')" style="min-width:10rem">
						<template #body="{ data }">
							{{ data.app_version }}
						</template>
					</Column>
					<Column field="name" :header="$t('showerDevice.columns.deviceName')" style="min-width:12rem">
						<template #body="{ data }">
							{{ data.name }}
						</template>
					</Column>

					<Column field="name" :header="$t('showerDevice.columns.location')" style="min-width:20rem">
						<template #body="{ data }">
							{{ data.enterprise_name }}->{{ data.enterprise_partition_name }}->{{ data.region_name }}
						</template>
					</Column>

					<Column field="name" :header="$t('showerDevice.columns.online')" style="min-width:6rem">
						<template #body="{ data }">
							<span :class="'customer-badge status-' + (data.status === 0 ? 'unqualified' : 'qualified')">{{
								data.status
								=== 0 ? $t('showerDevice.states.offline') : $t('showerDevice.states.online') }}</span>
						</template>
					</Column>
					<Column field="name" :header="$t('showerDevice.columns.lastHeartbeat')" style="min-width:8rem">
						<template #body="{ data }">
							{{ getFormatDatetime(data.online_time) }}
						</template>
					</Column>

					<Column field="name" :header="$t('showerDevice.columns.shampoo')" style="min-width:6rem">
						<template #body="{ data }">
							{{ data.head_fluid > data.fluid_thresh ? $t('showerDevice.states.high') : $t('showerDevice.states.low') }}
						</template>
					</Column>
					<Column field="name" :header="$t('showerDevice.columns.bodyWash')" style="min-width:6rem">
						<template #body="{ data }">
							{{ data.body_fluid > data.fluid_thresh ? $t('showerDevice.states.high') : $t('showerDevice.states.low') }}
						</template>
					</Column>
					<Column field="name" :header="$t('showerDevice.columns.roomTemp')" style="min-width:6rem">
						<template #body="{ data }">
							{{ data.env_temp }}℃
						</template>
					</Column>
					<Column field="name" :header="$t('showerDevice.columns.waterFlowThreshold')" style="min-width:8rem">
						<template #body="{ data }">
							{{ data.water_speed_thresh }}{{ $t('showerDevice.units.litersPerMinute') }}
						</template>
					</Column>

					<Column :header="$t('showerDevice.columns.actions')" style="min-width:7rem">
						<template #body="{ data }">
							<span class="p-input-icon-left">
								<Button :label="$t('showerDevice.edit')" class="p-button-success p-button-text mr-1" @click="openEditDevice(data)"
									v-if="locaInfo.admin != 0" />
								<!-- <Button label="删除" class="p-button-danger p-button-text mr-1"
									@click="delCamera(data, $event)" v-if="locaInfo.admin != 0" /> -->
							</span>
						</template>
					</Column>
				</DataTable>
			</div>
		</div>
	</div>


	<Dialog :header="deviceDialogTitle" v-model:visible="displayAddDevice" :style="{ width: '50vw' }" :modal="true">
		<div class="field p-fluid">
			<label for="deviceSN" class="font-bold">{{ $t('showerDevice.filters.sn') }}</label>
			<InputText id="deviceSN" type="text" class="p-error" v-model="deviceInfo.sn" disabled
				aria-describedby="deviceSN-help" />
		</div>
		<div class="field p-fluid mt-2">
			<label for="deviceEnterprise" class="font-bold">{{ $t('showerDevice.dialog.deviceLocation') }}</label>
			<div class="grid">
				<span class="p-float-label mr-3 mt-2 ml-2">
					<Dropdown id="deviceEnterprise" :options="enterpriseList" v-model="deviceInfo.enterpriseId" dataKey="id"
						optionLabel="name" optionValue="id" filter @change="onEnterpriseChange()" :placeholder="$t('showerDevice.filters.enterprise')"
						:show-clear="true"></Dropdown>
				</span>
				<span class="p-float-label mr-3 mt-2 ml-2">
					<Dropdown id="cameraField" :options="fieldList" v-model="deviceInfo.enterprisePartitionId" dataKey="id"
						:placeholder="$t('showerDevice.filters.field')" optionLabel="site_name" optionValue="id" filter @change="onFieldChange()"
						:show-clear="true">
					</Dropdown>
				</span>
				<span class="p-float-label mr-3 mt-2 ml-2">
					<Dropdown id="cameraRegion" :options="regionList" v-model="deviceInfo.regionId" dataKey="id"
						:placeholder="$t('showerDevice.filters.region')" optionLabel="region_name" optionValue="id" filter @change="onRegionChange()"
						:show-clear="true">
					</Dropdown>
				</span>
			</div>
		</div>
		<div class="field p-fluid mt-2">
			<label for="deviceName" class="font-bold">{{ $t('showerDevice.dialog.deviceName') }}</label>
			<InputText id="deviceName" type="text" class="p-error" v-model="deviceInfo.name" />
		</div>

		<div class="field p-fluid mt-2">
			<label for="" class="font-bold">{{ $t('showerDevice.dialog.basicParams') }}</label>
			<div class="grid">
				<div class="col">
			<label for="height">{{ $t('showerDevice.dialog.height') }}</label>
					<InputText id="height" type="text" class="p-error" v-model="deviceInfo.height"
						aria-describedby="height-help" />
				</div>
				<div class="col">
			<label for="waterFlow">{{ $t('showerDevice.dialog.minWaterFlow') }}</label>
					<InputText id="waterFlow" type="text" class="p-error" v-model="deviceInfo.waterFlow"
						aria-describedby="waterFlow-help" />
				</div>
				<div class="col">
			<label for="headTime">{{ $t('showerDevice.dialog.headDuration') }}</label>
					<InputText id="headTime" type="text" class="p-error" v-model="deviceInfo.headTime"
						aria-describedby="headTime-help" />
				</div>
				<div class="col">
			<label for="validTime">{{ $t('showerDevice.dialog.validDuration') }}</label>
					<InputText id="validTime" type="text" class="p-error" v-model="deviceInfo.validTime"
						aria-describedby="validTime-help" />
				</div>
			</div>
			<div class="grid">
				<div class="col">
			<label for="shampoo">{{ $t('showerDevice.dialog.shampooCount') }}</label>
					<InputText id="shampoo" type="text" class="p-error" v-model="deviceInfo.shampoo"
						aria-describedby="shampoo-help" place />
				</div>
				<div class="col">
			<label for="lotion">{{ $t('showerDevice.dialog.bodyWashCount') }}</label>
					<InputText id="lotion" type="text" class="p-error" v-model="deviceInfo.lotion"
						aria-describedby="lotion-help" />
				</div>
				<div class="col">
				</div>
				<div class="col">
				</div>
			</div>
		</div>

		<div class="field p-fluid mt-2" v-if="locaInfo.admin != 0">
			<label for="videoUrl" class="font-bold">{{ $t('showerDevice.dialog.advancedParams') }}</label>
			<div class="grid">
				<div class="col">
					<label for="netType">{{ $t('showerDevice.dialog.networkType') }}</label>
					<Dropdown id="netType" :options="netTypeOpts" v-model="deviceInfo.netType" dataKey="value"
						:placeholder="$t('showerDevice.dialog.networkType')" optionLabel="text" optionValue="value">
					</Dropdown>
				</div>
				<div class="col" v-if="locaInfo.admin === 2">
					<label for="doorCtrlType">{{ $t('showerDevice.dialog.doorControlType') }}</label>
					<Dropdown id="doorCtrlType" :options="deviceInfo.doorCtrlOpts" v-model="deviceInfo.doorCtrlType"
						dataKey="value" :placeholder="$t('showerDevice.dialog.doorControlType')" optionLabel="text" optionValue="value">
					</Dropdown>
				</div>
				<div class="col" v-if="locaInfo.admin === 2">
					<label for="alarmLevel">{{ $t('showerDevice.dialog.detectionLevel') }}</label>
					<Dropdown id="alarmLevel" :options="deviceInfo.alarmLevelOpts" v-model="deviceInfo.alarmLevel"
						dataKey="value" :placeholder="$t('showerDevice.dialog.detectionLevel')" optionLabel="text" optionValue="value">
					</Dropdown>
				</div>
				<div class="col">
				</div>
			</div>
		</div>

		<div class="field p-fluid mt-2" v-if="locaInfo.admin === 2">
			<label for="customized" class="font-bold">{{ $t('showerDevice.dialog.customized') }}</label>
			<Dropdown id="customized" :options="deviceInfo.customOpts" v-model="deviceInfo.customized" dataKey="value"
				:placeholder="$t('showerDevice.dialog.customizedProgram')" optionLabel="text" optionValue="value"></Dropdown>
		</div>

		<div class="field p-fluid mt-2" v-if="(locaInfo.admin === 2 || locaInfo.admin === 3) && customParams">
			<label for="cameraJudgeRule" class="font-bold">{{ $t('showerDevice.dialog.userParams') }}</label>
			<div class="grid">
				<div class="col-12 md:col-4">
					<div class="field-checkbox mb-0">
						<Checkbox id="checkOption1" v-model="customParams.enable_anony" :binary="true" />
						<label for="checkOption1">{{ $t('showerDevice.dialog.enableAnonymous') }}</label>
					</div>
				</div>
				<div class="col-12 md:col-4">
					<div class="field-checkbox mb-0">
						<Checkbox id="checkOption2" v-model="customParams.enable_easy" :binary="true" />
						<label for="checkOption2">{{ $t('showerDevice.dialog.enableEasy') }}</label>
					</div>
				</div>
			</div>
			<div class="grid">
				<div class="col-12 md:col-6">
					<label for="inputValidEasy">{{ $t('showerDevice.dialog.validTimeEasy') }}</label>
					<InputText id="inputValidEasy" type="text" placeholder="15" v-model="customParams.hard_mode_valid"></InputText>
				</div>
				<div class="col-12 md:col-6">
					<label for="inputTotalEasy">{{ $t('showerDevice.dialog.totalTimeEasy') }}</label>
					<InputText id="inputTotalEasy" type="text" placeholder="30" v-model="customParams.hard_mode_total"></InputText>
				</div>
			</div>
			<div class="grid">
				<div class="col-12 md:col-6">
					<label for="annoyHeight">{{ $t('showerDevice.dialog.anonymousHeight') }}</label>
					<InputText id="annoyHeight" type="text" placeholder="155" v-model="customParams.user_height"></InputText>
				</div>
				<div class="col-12 md:col-6">
					<label for="showerType">{{ $t('showerDevice.dialog.showerType') }}</label>
					<Dropdown id="showerType" :options="customTypeOpts" v-model="customParams.type" dataKey="value"
						:placeholder="$t('showerDevice.dialog.showerType')" optionLabel="text" optionValue="value"
						:disabled="customTypeLoading"></Dropdown>
				</div>
			</div>
		</div>

		<div class="field p-fluid mt-2" v-if="locaInfo.admin != 0 && bubbleParams">
			<label for="cameraJudgeRule" class="font-bold">{{ $t('showerDevice.dialog.bubbleParams') }}</label>
			<div class="grid">
				<div class="col-12 md:col-4">
					<div class="field-checkbox mb-0">
						<Checkbox id="checkOption1" v-model="bubbleParams.enable" :binary="true"/>
						<label for="checkOption1">{{ $t('showerDevice.dialog.enableBubble') }}</label>
					</div>
				</div>
			</div>
			<div class="grid">
				<div class="col-12 md:col-6">
					<label for="inputValidEasy">{{ $t('showerDevice.dialog.bubbleUsageCount') }}</label>
					<InputText id="inputValidEasy" type="text" placeholder="15" v-model="bubbleParams.count"></InputText>
				</div>
				<div class="col-12 md:col-6">
					<label for="inputTotalEasy">{{ $t('showerDevice.dialog.startTimer') }}</label>
					<InputText id="inputTotalEasy" type="text" placeholder="30" v-model="bubbleParams.before_valid"></InputText>
				</div>
			</div>
			<div class="grid">
				<div class="col-12 md:col-6">
					<label for="annoyHeight">{{ $t('showerDevice.dialog.bubbleDuration') }}</label>
					<InputText id="annoyHeight" type="text" placeholder="155" v-model="bubbleParams.time"></InputText>
				</div>
				<div class="col-12 md:col-6">
					<label for="showerType">{{ $t('showerDevice.dialog.algorithmType') }}</label>
					<InputText id="showerType" type="text" placeholder="default" :disabled="true"></InputText>
				</div>
			</div>
			<div class="grid">
				<div class="col-12 md:col-4">
					<label for="bubbleBeforeRinse">{{ $t('showerDevice.dialog.bubbleBeforeRinseTime') }}</label>
					<InputText id="bubbleBeforeRinse" type="text" placeholder="60" v-model="bubbleParams.valid_time_bef_bub"></InputText>
				</div>
				<div class="col-12 md:col-4">
					<label for="bubbleAfterRinse">{{ $t('showerDevice.dialog.bubbleAfterRinseTime') }}</label>
					<InputText id="bubbleAfterRinse" type="text" placeholder="180" v-model="bubbleParams.valid_time_aft_bub"></InputText>
				</div>
				<div class="col-12 md:col-4">
					<label for="bubbleAfterScrub">{{ $t('showerDevice.dialog.bubbleAfterScrubTime') }}</label>
					<InputText id="bubbleAfterScrub" type="text" placeholder="120" v-model="bubbleParams.nowater_time_aft_bub"></InputText>
				</div>
			</div>
		</div>


		<div class="field p-fluid mt-2" v-if="locaInfo.admin === 2">
			<label for="note" class="font-bold">{{ $t('showerDevice.dialog.note') }}</label>
			<Textarea v-model="deviceInfo.note" rows="5" cols="30" />
		</div>

		<template #footer>
					<Button :label="$t('common.actions.cancel')" icon="pi pi-times" @click="displayAddDevice = false" class="p-button-text" />
					<Button :label="$t('common.actions.confirm')" icon="pi pi-check" @click="onEditDeviceConfirm" autofocus />
		</template>
	</Dialog>
</template>

<script>
import { xlsx_exprot } from "@/utils/xlsx-export";
import { getToken } from '../utils/auth';
import dateUtil from '../utils/dateUtil.js'

export default {
	data() {
		return {
			dateUtil,

			displayAddDevice: false,
			expandedRows: [],

			//---------------------------------------------
			searchParams: {
				enterpriseId: null,
				enterprisePartitionId: null,
				regionId: null,
				personnelId: null,
				isOnline: null,
				isDeploy: null,
				sn: null
			},

			totalCount: 0, // 数据总数
			pageIndex: 1, // 当前页数
			pageSize: 10, // 每页条数

			deviceList: [],

			deviceInfo: {
				id: null,
				uuid: null,
				sn: null,
				enterpriseId: null,
				name: null,
				enterprisePartitionId: null,
				height: null,
				headTime: null,
				validTime: null,
				shampoo: null,
				lotion: null,
				waterFlow: null,
				netType: null,
				regionId: null,
				note: null,
				antiCheat: null,
				customOpts: [],
				customized: null,
				customParams: null,
				customParamsTemplate: {},
				alarmLevelOpts: [],
				alarmLevel: null,
				doorCtrlOpts: [],
				doorCtrlType: null,
			},

			deviceDialogTitle: '',

			enterpriseList: null,
			fieldList: null,
			regionList: null,
			onlineStOpts: [],
			deployStOpts: [],
			netTypeOpts: [
				{
					text: '',
					value: 0
				},
				{
					text: "4G",
					value: 1
				},
				{
					text: "WIFI",
					value: 2
				}
			],
			displayLoading: false,
			displayRules: false,
			text: '',

			ruleData: {
				start_time: "",
				state_branch: "",
				end_time: "",
				end_branch: "",
				status: false,
				input: "",
				inputone: "",
				inputtwo: "",
				content: "",
			},
			uploadUrl: '',
			isAdmin: false,
			customTypeOpts: [],
			customTypeLoading: false,
			customTypeLoadFailed: false,
			customTypeRequestToken: 0,
			//---------------------------------------------
			selectedDevice: null,

			// customParams: {
			// 	sn: 250831401010084,
			// 	custom: {
			// 		enable_anony: 0,
			// 		enable_easy: 1,
			// 		hard_mode_valid: 15,
			// 		hard_mode_total: 30,
			// 		user_height: 155,
			// 		type: "default"
			// 	}
			// },
			customParams: null,

			// bubbleParams:{
			// 	sn: 2511413020210109,
			// 	bubble:{
			// 		before_valid: 1,
			// 		count: 1,
			// 		enable: 0,
			// 		min_water_sp: 0,
			// 		alg_type: 4,
			// 		time: 8
			// 	}
			// },
			bubbleParams: null,
		}
	},
	created() {
		this.searchParams.enterpriseId = this.$route.query.enterprise_id;
		this.searchParams.enterprisePartitionId = this.$route.query.enterprise_partition_id;
		if (this.$route.query.enterprise_id != "") {
			this.getFieldList(this.$route.query.enterprise_id);
		}
		this.locaInfo = JSON.parse(window.localStorage.getItem('userinfo'));

		this.getEnterpriseList();
		if (this.locaInfo.type != "ad") {
			this.getFieldList(this.locaInfo.id);
		}
		this.getDeviceList();
		this.syncLocalizedOptions();
	},
	watch: {
		'$appState.locale'() {
			this.syncLocalizedOptions();
		}
	},
	mounted() {

	},
	methods: {
		syncLocalizedOptions() {
			this.deviceDialogTitle = this.$t('showerDevice.dialog.editTitle');
			this.onlineStOpts = [
				{ value: -1, text: this.$t('showerDevice.states.all') },
				{ value: 0, text: this.$t('showerDevice.states.offline') },
				{ value: 1, text: this.$t('showerDevice.states.online') },
			];
			this.deployStOpts = [
				{ value: -1, text: this.$t('showerDevice.states.all') },
				{ value: 0, text: this.$t('showerDevice.states.notDeployed') },
				{ value: 1, text: this.$t('showerDevice.states.deployed') },
			];
			this.netTypeOpts = [
				{ text: this.$t('showerDevice.states.wiredNetwork'), value: 0 },
				{ text: '4G', value: 1 },
				{ text: 'WIFI', value: 2 }
			];
		},
		getFormatDatetime(tim) {
			return dateUtil.formatDatetime(new Date(tim));
		},
		errorMessage(msg) {
			this.$toast.add({ severity: 'error', summary: this.$t('common.feedback.error'), detail: msg, life: 2000 });
		},
		goodMessage() {
			this.$toast.add({ severity: 'success', summary: this.$t('common.feedback.success'), life: 2000 });
		},
		getCurrentCustomType() {
			return this.customParams?.type || this.deviceInfo.customized || null;
		},
		normalizeCustomParams(params) {
			if (!params) {
				return null;
			}

			const currentType = params.type || this.deviceInfo.customized || null;

			return {
				...params,
				enable_anony: Boolean(params.enable_anony),
				enable_easy: Boolean(params.enable_easy),
				type: currentType
			};
		},
		syncCustomTypeOptions(options = []) {
			const currentType = this.getCurrentCustomType();
			const mappedOptions = [...options];

			if (currentType && !mappedOptions.some((option) => option.value === currentType)) {
				mappedOptions.push({
					text: currentType,
					value: currentType
				});
			}

			this.customTypeOpts = mappedOptions;
		},
		loadCustomTypeOptions() {
			const requestToken = ++this.customTypeRequestToken;
			this.customTypeLoading = true;
			this.customTypeLoadFailed = false;
			this.syncCustomTypeOptions();

			this.$http('/api/admin/bathdevice/customTypes', {}).then((res) => {
				if (requestToken !== this.customTypeRequestToken) {
					return;
				}

				if (res.code == 200) {
					const options = (res.data || []).map((item) => ({
						text: item.alias || item.type,
						value: item.type
					}));

					this.syncCustomTypeOptions(options);
					this.customTypeLoadFailed = false;
				} else {
					this.syncCustomTypeOptions();
					this.customTypeLoadFailed = true;
				}
			}).catch(() => {
				if (requestToken !== this.customTypeRequestToken) {
					return;
				}

				this.syncCustomTypeOptions();
				this.customTypeLoadFailed = true;
			}).finally(() => {
				if (requestToken === this.customTypeRequestToken) {
					this.customTypeLoading = false;
				}
			});
		},
		// 获取企业列表
		getEnterpriseList() {
			this.$http("/api/admin/enterprise/index", {}).then((res) => {
				if (res.code == 200) {
					this.enterpriseList = res.data;
				}
			});
		},
		onEnterpriseChange(type) {
			if (type == "search") {
				this.getFieldList(this.searchParams.enterpriseId);
			} else {
				this.getFieldList(this.deviceInfo.enterpriseId);
			}
		},

		// 获取场地列表
		getFieldList(enterprise_id) {
			this.$http("/api/admin/partition/index", { enterprise_id }).then(
				(res) => {
					if (res.code == 200) {
						this.fieldList = res.data.data;
					}
				}
			);
		},
		onFieldChange(type) {
			if (type == "search") {
				this.getRegionList(this.searchParams.enterprisePartitionId);
			} else {
				this.getRegionList(this.deviceInfo.enterprisePartitionId);
			}
		},

		onBeforeSendCameraFile(e) {
			e.xhr.setRequestHeader('admintoken', getToken());
		},

		// 获取区域列表
		getRegionList(enterprise_partition_id) {
			this.$http("/api/admin/region/cdindex", {
				enterprise_partition_id: enterprise_partition_id
			}).then((res) => {
				if (res.code == 200) {
					this.regionList = res.data;
				}
			});
		},
		onRegionChange() {
			// this.getPositionList(this.deviceInfo.region);
		},

		// 获取位置列表
		getPositionList(top_id) {
			this.$http("/api/admin/region/xjindex", { top_id }).then((res) => {
				if (res.code == 200) {
					this.positionList = res.data;
				}
			});
		},
		onPositionChange() {
			let name = this.positionList.filter((res) => {
				return res.id == this.deviceInfo.position;
			})[0].region_name;
			this.deviceInfo.camera = name;
		},

		onPage(event) {
			this.pageIndex = event.page + 1;
			this.getDeviceList();
		},

		getDeviceList() {
			this.$http('/api/admin/bathdevice/index', {
				enterprise_id: JSON.parse(window.localStorage.getItem('userinfo')).type == 'ad' ? this.searchParams.enterpriseId : JSON.parse(window.localStorage.getItem('userinfo')).enterprise_id,
				enterprise_partition_id: this.searchParams.enterprisePartitionId,
				region_id: this.searchParams.regionId,
				page: this.pageIndex,
				page_size: this.pageSize,
				sn: this.searchParams.sn,
				is_online: this.searchParams.isOnline === -1 ? '' : this.searchParams.isOnline,
				is_deploy: this.searchParams.isDeploy === -1 ? '' : this.searchParams.isDeploy,
			}).then(res => {
				if (res.code == 200) {
					this.totalCount = res.data.total;
					this.deviceList = res.data.data;
				} else {
					this.$toast.add({ severity: 'error', summary: res.msg, life: 2000 });
				}
			})
		},

		getCustomParams(item_sn) {
			this.$http("/api/admin/bathdevice/custom", {
				sn: item_sn
			}).then(res => {
				if (res.code == 200) {
					this.customParams = this.normalizeCustomParams(res.data);
					this.loadCustomTypeOptions();

					console.log(res.data);
				} else {
					this.$toast.add({ severity: 'error', summary: res.msg, life: 2000 });
				}
			})
		},

		openEditDevice(item) {
			this.$http("/api/admin/bathdevice/detail", {
				sn: item.sn,
			}).then(res => {
				if (res.code == 200) {
					this.deviceInfo.customOpts = [];
					for (let v in res.data.custom_opts) {
						this.deviceInfo.customOpts.push({
							text: res.data.custom_opts[v],
							value: v
						})
					}

					this.deviceInfo.customized = res.data.custom_type;
					this.deviceInfo.note = res.data.note2;

					this.deviceInfo.alarmLevelOpts = []
					for (let i = 0; i < res.data.anti_cheat_opts.length; i++) {
						this.deviceInfo.alarmLevelOpts.push({
							text: res.data.anti_cheat_opts[i],
							value: i
						})
					}

					this.deviceInfo.alarmLevel = res.data.anti_cheat;

					this.deviceInfo.doorCtrlOpts = [];
					for (let v in res.data.door_opts) {
						this.deviceInfo.doorCtrlOpts.push({
							text: res.data.door_opts[v],
							value: v
						})
					}
					this.deviceInfo.doorCtrlType = res.data.door_type;

					//this.device.uuid = res.data.uuid;
					this.deviceInfo.id = res.data.id;
					this.deviceInfo.sn = res.data.sn;
					this.deviceInfo.name = res.data.name;
					this.deviceInfo.height = res.data.height;
					this.deviceInfo.headTime = res.data.head_thresh;
					this.deviceInfo.validTime = res.data.total_thresh;
					this.deviceInfo.lotion = res.data.body_fluid_thresh;
					this.deviceInfo.shampoo = res.data.head_fluid_thresh;
					this.deviceInfo.waterFlow = res.data.water_speed_thresh;
					this.deviceInfo.enterpriseId = res.data.enterprise_id;
					this.deviceInfo.enterprisePartitionId = res.data.enterprise_partition_id;
					this.deviceInfo.regionId = res.data.region_id;
					this.deviceInfo.netType = res.data.is4G;
					this.deviceInfo.note = res.data.note2;
					this.customParamsList = [];

					this.getFieldList(this.deviceInfo.enterpriseId);
					this.getRegionList(this.deviceInfo.enterprisePartitionId);

					this.customParams = null;
					this.bubbleParams = null;
					this.customTypeOpts = [];
					this.customTypeLoading = false;
					this.customTypeLoadFailed = false;
					this.customTypeRequestToken += 1;
					this.$http("/api/admin/bathdevice/bubble", {
						sn: item.sn,
					}).then(res => {
						if (res.code == 200) {
							this.bubbleParams = res.data;
							this.bubbleParams.enable = Boolean(res.data.enable)
							//console.log(this.bubbleParams)
						} else {
							//this.$toast.add({ severity: 'error', summary: res.msg, life: 2000 });
						}
					})

					this.$http("/api/admin/bathdevice/custom", {
						sn: item.sn,
					}).then(res => {
						if (res.code == 200) {
							this.customParams = this.normalizeCustomParams(res.data);
							this.loadCustomTypeOptions();

							//console.log(this.customParams)							
						} else {
							//this.$toast.add({ severity: 'error', summary: res.msg, life: 2000 });
						}
					})
					
					this.displayAddDevice = true;
				} else {
					this.$toast.add({ severity: 'error', summary: res.msg, life: 2000 });
				}
			})
		},

		onEditDeviceConfirm() {
			var newReg = /^[0-9]+$/;

			if (!newReg.test(this.deviceInfo.height)) {
				this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.invalidHeight'), life: 2000 });
				return;
			}

			if (!newReg.test(this.deviceInfo.headTime)) {
				this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.invalidHeadDuration'), life: 2000 });
				return;
			}

			if (!newReg.test(this.deviceInfo.validTime)) {
				this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.invalidValidDuration'), life: 2000 });
				return;
			}

			if (!newReg.test(this.deviceInfo.lotion)) {
				this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.invalidBodyWashDuration'), life: 2000 });
				return;
			}

			if (!newReg.test(this.deviceInfo.shampoo)) {
				this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.invalidShampooDuration'), life: 2000 });
				return;
			}

			if (!newReg.test(this.deviceInfo.waterFlow)) {
				this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.invalidWaterFlow'), life: 2000 });
				return;
			}

			if (Number.parseInt(this.deviceInfo.height) < 170 ||
				Number.parseInt(this.deviceInfo.height) > 250) {
				this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.unsupportedHeight'), life: 2000 });
				return
			}

			if (Number.parseInt(this.deviceInfo.waterFlow) > 8 ||
				Number.parseInt(this.deviceInfo.waterFlow) < 0) {
				this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.unsupportedWaterFlow'), life: 2000 });
				return
			}

			if (this.bubbleParams) {
				if (!newReg.test(this.bubbleParams.valid_time_bef_bub)) {
					this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.invalidBubbleBeforeRinseTime'), life: 2000 });
					return;
				}

				if (!newReg.test(this.bubbleParams.valid_time_aft_bub)) {
					this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.invalidBubbleAfterRinseTime'), life: 2000 });
					return;
				}

				if (!newReg.test(this.bubbleParams.nowater_time_aft_bub)) {
					this.$toast.add({ severity: 'error', summary: this.$t('showerDevice.messages.invalidBubbleAfterScrubTime'), life: 2000 });
					return;
				}
			}

			this.$http("/api/admin/bathdevice/create", {
				id: this.deviceInfo.id == -1 ? "" : this.deviceInfo.id,
				sn: this.deviceInfo.sn,
				enterprise_id: this.deviceInfo.enterpriseId,
				enterprise_partition_id: this.deviceInfo.enterprisePartitionId,
				region_id: this.deviceInfo.regionId,
				name: this.deviceInfo.name,
				height: this.deviceInfo.height,
				head_thresh: this.deviceInfo.headTime,
				total_thresh: this.deviceInfo.validTime,
				head_fluid: this.deviceInfo.shampoo,
				body_fluid: this.deviceInfo.lotion,
				water_speed: this.deviceInfo.waterFlow,
				is4G: this.deviceInfo.netType,
				note2: this.deviceInfo.note,
				anti_cheat: this.deviceInfo.alarmLevel,
			}).then((res) => {
				if (res.code == 200) {
					
					//更新custom參數
					if(this.customParams){
						this.$http("/api/admin/bathdevice/setcust", { 
							sn: this.deviceInfo.sn,
							custom: {
								enable_anony: this.customParams.enable_anony?1:0,
								enable_easy: this.customParams.enable_easy?1:0,
								hard_mode_valid: this.customParams.hard_mode_valid,
								hard_mode_total: this.customParams.hard_mode_total,
								user_height: this.customParams.user_height,
								type: this.getCurrentCustomType()
							}
						}).then((res) => {
							if (res.code != 200) {
								this.$toast.add({ severity: 'error', summary: res.msg, life: 2000 });
							}
						})
					}

					//更新bubble參數
					if(this.bubbleParams){
						this.$http("/api/admin/bathdevice/setbub", { 
							sn: this.deviceInfo.sn,
							bubble:{
								before_valid: this.bubbleParams.before_valid,
							count: this.bubbleParams.count,
							enable: this.bubbleParams.enable?1:0,
							min_water_sp: 0,
							alg_type: 4,
							time: this.bubbleParams.time,
							valid_time_bef_bub: this.bubbleParams.valid_time_bef_bub,
							valid_time_aft_bub: this.bubbleParams.valid_time_aft_bub,
							nowater_time_aft_bub: this.bubbleParams.nowater_time_aft_bub,
						}
					}).then((res) => { 
							if (res.code != 200) {
								this.$toast.add({ severity: 'error', summary: res.msg, life: 2000 });
							}
						})
					}
					
					this.getDeviceList();
					this.displayAddDevice = false;
				} else {
					this.$toast.add({ severity: 'error', summary: res.msg, life: 2000 });
				}
			});
		},

		onSearch() {
			this.getDeviceList();
		},
	},
}

</script>

<style scoped lang="scss">
@import '../assets/demo/badges.scss';

::v-deep(.p-datatable-frozen-tbody) {
	font-weight: bold;
}

::v-deep(.p-datatable-scrollable .p-frozen-column) {
	font-weight: bold;
}
</style>
